{
  "title": "مشاركة موقعك تساعدك على تسريع عملية تسجيل الوصول",
  "body": "نأسف، لكن لا يمكننا إتمام تسجيل وصولك دون الوصول إلى موقعك. يرجى منح إذن الوصول إلى الموقع للمتابعة. نستخدم موقعك فقط لأغراض تسجيل الوصول إلى المستودع ولا نقوم بتخزين أو مشاركة معلومات موقعك مع أطراف ثالثة.",
  "shareLocation": "مشاركة موقعي"
}
